import { Icon } from "@iconify/react";
import { Fragment, useEffect, useState } from "react";
import plusFill from "@iconify/icons-eva/plus-fill";
import iconEdit from "@iconify/icons-eva/edit-2-fill";
import iconDelete from "@iconify/icons-eva/person-delete-fill";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
// material
import { Card, Table, Stack, Switch, Button, TextField, TableRow, TableBody, TableCell, Container, Typography, TableContainer, RadioGroup, Radio, FormControlLabel, IconButton } from "@mui/material";
// components
import Page from "src/components/Page";
import Scrollbar from "src/components/Scrollbar";
import SearchNotFound from "src/components/SearchNotFound";

import MoreMenu from "src/components/common/MoreMenu";
import FormDialog from "src/components/common/FormDialog";
import FormItem from "src/components/form-item/FormItem";
import Confirm from "src/components/common/ConfirmDialog";
import { ArrowRight } from "@mui/icons-material";
import ListHead from "src/components/common/ListHead";
import { useSelector } from "react-redux";
import { getSystemMenus } from "src/services/request";
import { asyncRequest } from "src/services/network";
import TreeSelect from "src/components/lib/tree-select/TreeSelect";

const TABLE_HEAD = [
  { id: "uid", label: "菜单名称", alignRight: false },
  { id: "icon", label: "图标", alignRight: false },
  { id: "route", label: "菜单地址", alignRight: false },
  // { id: "api", label: "权限api", alignRight: false },
  { id: "order", label: "排序", alignRight: false },
  { id: "isShow", label: "是否显示", alignRight: false },
  { id: "isMenu", label: "是否菜单", alignRight: false },
  { id: "createdAt", label: "创建时间", alignRight: false },
  { id: "operation" }
];

const moreMenus = [
  { title: "添加子菜单", icon: plusFill },
  { title: "编辑", icon: iconEdit },
  { title: "删除", icon: iconDelete },
];

function SystemMenuForm({ parentId, parentName, row, title, action, onClose, onConfirm }) {
  const { systemMenus, systemMenuHierarchy } = useSelector((state) => state.globalData);

  const [form, setForm] = useState({
    icon: "",
    name: "",
    route: "",
    api: "",
    order: 0,
    isMenu: 1,
    isShow: true,
    pid: 0,
    pName: "",
  });

  // console.log(parentId, row)
  useEffect(() => {
    if (!row.id) {
      setForm({
        icon: "",
        name: "",
        route: "",
        api: "",
        order: 0,
        isMenu: 1,
        isShow: true,
        pid: parentId,
        pName: parentName,
      });
      return;
    }

    let pid = parentId;
    let pName = "顶级";
    if (parentId) {
      const parent = systemMenus.find((m) => m.id === parentId);
      pid = parent.id;
      pName = parent.name;
    }

    setForm({
      isMenu: row.isMenu ? 1 : 0,
      isShow: row.isShow,
      icon: row.icon,
      order: row.order,
      name: row.name,
      route: row.route,
      api: row.api,
      pid,
      pName,
    });

  }, [row, parentId]);

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handleConfirm() {

    onConfirm(form);
  }

  return (
    <FormDialog
      title={action === "add" ? "添加菜单" : "修改菜单"}
      open={!!action} onClose={onClose} onConfirm={handleConfirm}>

      <FormItem title="父级菜单" required style={{minWidth: 500}}>
        <TreeSelect
          data={systemMenuHierarchy}
          value={form.pid}
          onChange={(v) => handleIptChange("pid", v)}
          fullWidth
        />
      </FormItem>

      <FormItem title="菜单类型" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isMenu}>
          <FormControlLabel value={1} control={<Radio />} label="菜单" onChange={(e) => handleIptChange("isMenu", parseInt(e.target.value))} />
          <FormControlLabel value={0} control={<Radio />} label="权限" onChange={(e) => handleIptChange("isMenu", parseInt(e.target.value))} />
        </RadioGroup>
      </FormItem>

      <FormItem title="菜单名" required>
        <TextField fullWidth placeholder="菜单名" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
      </FormItem>

      <FormItem title="菜单图标">
        <TextField fullWidth placeholder="菜单图标" autoComplete="off" id="icon" value={form.icon} size="small" onChange={(e) => handleIptChange("icon", e.target.value)} />
      </FormItem>

      <FormItem title="路由规则" required>
        <TextField fullWidth placeholder="路由规则" autoComplete="off" id="route" value={form.route} size="small" onChange={(e) => handleIptChange("route", e.target.value)} />
      </FormItem>

      {/* <FormItem title="接口路由">
        <TextField fullWidth placeholder="接口路由" autoComplete="off" id="api" value={form.api} size="small" onChange={(e) => handleIptChange("api", e.target.value)} />
      </FormItem> */}

      <FormItem title="排序">
        <TextField fullWidth placeholder="排序" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
      </FormItem>

      <FormItem title="权限状态" required>
        <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.isShow}>
          <FormControlLabel value={true} control={<Radio />} label="显示" onChange={(e) => handleIptChange("isShow", e.target.value)} />
          <FormControlLabel value={false} control={<Radio />} label="隐藏" onChange={(e) => handleIptChange("isShow", e.target.value)} />
        </RadioGroup>
      </FormItem>
    </FormDialog>
  )
}

export default function SystemMenu() {
  const { systemMenuHierarchy } = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const [foldMap, setFoldMap] = useState({});

  const [action, setAction] = useState("");
  const [targetItem, setTargetItem] = useState({});
  const [parentId, setParentId] = useState(-1);
  const [parentName, setParentName] = useState('');


  useEffect(() => {
    getSystemMenus(true);
  }, []);

  function handleAddMenu(pid = 0, pName = '顶级菜单') {
    setParentId(pid);
    setParentName(pName)
    setTargetItem({});
    setAction("add");
  }

  const handleMoreClick = (type, row) => {
    if (type === "编辑") {
      setParentId(row.pid);
      setTargetItem({ ...row });
      setAction("edit");
    } else if (type === "删除") {
      handleDelBanner(row.id);
    } else if (type === "添加子菜单") {
      handleAddMenu(row.id, row.name);
    }
  };

  function handleDelBanner(id) {
    Confirm({
      message: "删除不可恢复，确定删除吗?",
      async onConfirm() {
        await asyncRequest({
          path: "/system/menu/del",
          data: { id },
        })

        getSystemMenus(true);
      },
    });
  }

  async function handleDialogConfirm(form) {
    const formData = { ...form };

    if (action === "edit") {
      formData.id = targetItem.id;
    }

    await asyncRequest({
      path: action === "add" ? "/system/menu/add" : "/system/menu/edit",
      data: formData,
    })

    getSystemMenus(true);
    setAction("");
  }

  async function toggleShow(id, to) {
    await asyncRequest({
      path: "/system/menu/toggleShow",
      data: {
        id,
        isShow: to,
      }
    })

    getSystemMenus(true);
  }

  function handleFolding(row) {
    // console.log(row.pid, row.name, foldMap);
    setFoldMap({
      ...foldMap,
      [row.id]: !foldMap[row.id],
    });
  }

  const isUserNotFound = systemMenuHierarchy.length === 0;

  function renderTableRow(list, visible = true) {
    if (!list) return null;
    return list.map((row) => {
      const { id, name, icon, isShow, createdAt, route, isMenu, order, level, pid, children } = row;

      if (visible) {
        visible = foldMap[pid];
      }

      let display = "none";
      if (level === 1 || visible) {
        display = "";
      }

      return (
        <Fragment key={id}>
          <TableRow hover key={id} tabIndex={-1} role="checkbox" sx={{ display }}>
            <TableCell align="left" sx={{ pl: level - 1 }}>
              <IconButton onClick={() => handleFolding(row)} disabled={!children}>
                <ArrowRight sx={{ visibility: !children ? "hidden" : "visible", transform: `rotate(${foldMap[id] ? 90 : 0}deg)` }} />
              </IconButton>
              {name}
            </TableCell>
            <TableCell align="left">{icon}</TableCell>
            <TableCell align="left">{route}</TableCell>
            {/* <TableCell align="left">{api}</TableCell> */}
            <TableCell align="left">{order}</TableCell>
            <TableCell align="left">
              <Switch checked={isShow} onChange={e => toggleShow(id, e.target.checked)} />
            </TableCell>
            <TableCell align="left">
              <Switch checked={isMenu} onChange={e => {}} />
            </TableCell>
            <TableCell align="left">{moment(createdAt).format("YYYY-MM-DD HH:mm:ss")}</TableCell>
            <TableCell align="right">
              <MoreMenu spread menus={moreMenus} onMoreClick={(type) => handleMoreClick(type, row)} />
            </TableCell>
          </TableRow>
          {renderTableRow(children, visible)}
        </Fragment>
      );
    });
  }

  return (
    <Page title="菜单列表">
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            菜单列表
          </Typography>

          <Button variant="contained" to="add" startIcon={<Icon icon={plusFill} />} onClick={() => handleAddMenu()}>
            添加菜单
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <ListHead headLabel={TABLE_HEAD} rowCount={systemMenuHierarchy.length} />

                <TableBody>{renderTableRow(systemMenuHierarchy)}</TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        {/* <SearchNotFound searchQuery={filterName} /> */}
                        <SearchNotFound />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Card>
      </Container>

      <SystemMenuForm
        action={action}
        parentId={parentId}
        parentName={parentName}
        row={targetItem}
        onClose={() => setAction()} onConfirm={handleDialogConfirm}
      />
    </Page>
  );
}
